import PropTypes from 'prop-types';
import React from 'react';
import { HighchartReactWrapper } from '@bingads-webui-react/highchart-react-wrapper';
import { getNewStrengthScore, getStrengthColor } from './ad-strength-helper';

export function NewAdStrengthScore({
  strength, width,
}) {
  if (!strength) return null;

  const score = getNewStrengthScore(strength);
  const color = getStrengthColor(strength);
  const options = {
    chart: {
      width,
      height: 12,
      margin: [0, 0, 0, 0],
      type: 'bar',
    },
    title: {
      text: null,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      tickPositions: [-0.2, 100.2],
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
      formatter: null,
    },
    plotOptions: {
      bar: {
        animation: false,
        pointWidth: 16,
      },
      series: {
        stacking: 'normal',
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            enabled: false,
          },
        },
      },
    },
    series: [{
      data: [100-score],
      color: '#D9D9D9',
    }, {
      data: [0.2],
      color: '#FFFFFF',
    }, {
      data: [score],
      color,
    },
    ],
  };

  return (
    <HighchartReactWrapper
      className="ad-strength-score ad-strength-score-vnext"
      options={options}
    />
  );
}

NewAdStrengthScore.propTypes = {
  strength: PropTypes.string,
  width: PropTypes.number,
};

NewAdStrengthScore.defaultProps = {
  strength: '',
  width: 418,
};
